module.exports = __webpack_public_path__ + "static/img/creation.e0f9cc5c.png";